import React from "react";
import "./style.css";

export const Footer = () => {

  return (
    <div className="footer" >
      <a className="footer-button" href="/article/0x16919da1e9ef808fe7bd016697a1b2b2869185ca266bc1ebd763bdd899b33614">Help</a>
      <a className="footer-button" href="/user/github/Bubble-Protocol">Blog</a>
      <a className="footer-button" href="/article/0xb42117a47b714bde79462b2df6a6cec230d14f60cf78a95d411ed531c6510593">Terms</a>
      <a className="footer-button" href="/article/0x3d1733d3a0635a790df5eb6012e5af6b14ad0333c42b5bb6d9c4298971ae4241">About</a>
      <a className="footer-button" href="https://github.com/Bubble-Protocol/seedling">Code</a>
    </div>
  );
};
